<template>
  <div>
    <b-form-group
      horizontal
      :label="label"
      label-class="font-weight-semibold text-gray-700"
      v-if="state == 'creating' || state == 'updating'"
    >
      <template #label>
        <slot name="label"></slot>
      </template>
      <b-form-select
        v-if="type == 'select'"
        :options="options"
        :value="value"
        @input="$emit('input', $event)"
      ></b-form-select>
      <b-form-checkbox
        v-else-if="type == 'checkbox'"
        :checked="value == 1"
        @input="$emit('input', $event)"
      ></b-form-checkbox>
      <b-textarea
        v-else-if="type == 'textarea'"
        :value="value"
        @input="$emit('input', $event)"
      ></b-textarea>
      <b-form-input
        v-else
        :type="type"
        :value="value"
        @input="$emit('input', $event)"
      ></b-form-input>
      <p class="text-sm mb-0 text-gray-700"><slot name="info"></slot></p>
    </b-form-group>
    <div v-else-if="state == 'showing'">
      <span v-if="type == 'select'">
        <slot name="label-text" :labelText="label" :value="optionText(value)">{{ label }} {{ optionText(value) }}</slot>
      </span>
      <span v-else-if="type == 'checkbox'">
        <span v-if="value == 1">
          <slot name="label-text" :value="value">{{ label }}</slot>
        </span>
      </span>
      <span v-else>
        <span v-if="label"><slot name="label-text" :labelText="label" :value="value">{{ label }} {{ value }}</slot></span>
      </span>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: ["type", "options", "label", "value"],
  computed: mapState({
    state: (state) => state.employeeManager.state,
  }),
  methods: {
    optionText(value) {
      var v = this.options.find((o) => o.value == value);
      if (typeof v === "undefined") return "Sin asignar";
      return v.text;
    },
  },
};
</script>
